import './LanguageSwitcher.scss'
import React from 'react'
import ClickAwayListener from '@material-ui/core/ClickAwayListener'
import { Grow, Paper, Popper, MenuItem, MenuList } from '@material-ui/core'
import { useCookies } from 'react-cookie';

import EN from './images/EN.png'
import RU from './images/RU.png'

const LanguageSwitcher = () => {

    const languages = [
        { name: 'EN', value: 'en-us', image: EN },
        { name: 'RU', value: 'ru', image: RU }
    ];

    const [cookies, setCookie] = useCookies(['locale']);
    const [currentLanguage, setCurrentLanguage] = React.useState(languages.find(x => x.value === cookies.locale) || languages[0]);

    const [openModal, setOpenModal] = React.useState(false);
    const anchorRef = React.useRef(null);

    const handleToggle = () => {
        setOpenModal((prevOpen) => !prevOpen);
    };

    const handleClose = (event) => {
        if (anchorRef.current && anchorRef.current.contains(event.target)) {
            return;
        }

        setOpenModal(false);
    };

    const handleChange = (lang) => {
        setCurrentLanguage(languages.find(x => x.value === lang));
        setCookie('locale', lang)
        setOpenModal(false);
    }

    return (
        <div className='language-switcher'>
            <div ref={anchorRef} onClick={handleToggle}>
                <img className='language-image' src={currentLanguage.image} alt={currentLanguage.name} />
                {currentLanguage.name}
                <span>&#x25BE;</span>
            </div>

            <Popper style={{ zIndex: 1 }} open={openModal} anchorEl={anchorRef.current} transition disablePortal>
                {({ TransitionProps, placement }) => (
                    <Grow {...TransitionProps} style={{ transformOrigin: placement === 'bottom' ? 'center top' : 'center bottom' }}>
                        <Paper>
                            <ClickAwayListener onClickAway={handleClose}>
                                <MenuList autoFocusItem={openModal} id='menu-list-grow'>
                                    {languages.map((x) =>
                                        <MenuItem key={x.name} onClick={() => handleChange(x.value)}>
                                            <img className='language-image' src={x.image} alt={x.name} />
                                            {x.name}
                                        </MenuItem>)}
                                </MenuList>
                            </ClickAwayListener>
                        </Paper>
                    </Grow>
                )}
            </Popper>
        </div>
    )
}

export default LanguageSwitcher
